module.exports = __webpack_public_path__ + "img/infibo-review-screenshot-ru.0625f97e.png";